import { useContext, useEffect } from "react";
import { notificationContext } from "../../ContextAPI/showNotification";
import "./styles.css";
const Notification = (props) => {
  const [notification, setNotification] = useContext(notificationContext);
  useEffect(() => {
    const timer = setTimeout(() => {
      setNotification((prev) => {
        return { ...prev, visible: false };
      });
    }, 4000);
    return () => clearTimeout(timer);
  }, [notification.visible]);

  return notification.visible ? (
    <div className="notification">{notification.message}</div>
  ) : null;
};

export default Notification;
